import { LOCAL } from '../../constants/FJEvnConstant';
import FJVersionConfig from '../FJVersionConfig.js';
const environment = import.meta.env.MODE;

export default {
    stylePath: environment === LOCAL ? `/public/img/clothesChanger/` : `/app/ai-tools/img/clothesChanger/`,
    originalImageKey: 'ai/input/clothes-changer/',
    resultImageKey: 'ai/export/try-on/',
    historyListType: 10,
    unitPrice: 8, // 一次换装扣的费用
    freeLimitType: 'clothes-changer',
    currentMenuName: 'ai-clothes-changer',
    notImageBoxDesc: 'clothes-advertisement-desc',
    notImageBoxTitle: 'clothes-advertisement-title',
    notImageBoxBgUrl:
        environment === LOCAL
            ? `/public/img/clothesChanger/demonstration/background.png?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/clothesChanger/demonstration/background.png?v=${FJVersionConfig.staticPathVersion}`,
    notImageBoxVideoUrl:
        environment === LOCAL
            ? `/public/img/clothesChanger/demonstration/video.mp4?v=${FJVersionConfig.staticPathVersion}`
            : `/app/ai-tools/img/clothesChanger/demonstration/video.mp4?v=${FJVersionConfig.staticPathVersion}`,
    tipsImagePath:
        environment === LOCAL ? `/public/img/clothesChanger/tips/` : `/app/ai-tools/img/clothesChanger/tips/`,
};
